import React, { Component, Suspense } from "react";
import { Container, Alert } from "reactstrap";
import styles from "./DefaultLayout.module.scss";
import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  // AppSidebarNav,
} from "@coreui/react";
import navigation from "../../_nav";
import { connect } from "react-redux";
import { runSetupForCompanyWorkshop } from "../../redux/actions/aUser-Company-Initialize";
import Notification from "./NotificationWrapper";
import AuthCheck from "./AuthCheck";
import WalletPayment from "./WalletPayment";
import DefaultTemplate from "../../components/Template/DefaultTemplate/DefaultTemplate";
import DefaultSidebar from "./DefaultSidebar/DefaultSidebar";
import { wording } from "src/constants/constants";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      filteredNav: null,
    };
  }

  flatArray = (value=[]) => {
    
    let newArr = [];
    for(let i=0; i < value.length; i++){
      if(!!value[i].children && value[i].children>0){
        newArr = [...newArr, ...this.flatArray(value[i].children)];
      }
      else{
        newArr = [...newArr, value[i]];
      }
    }

    return newArr;
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );

  componentDidMount() {
    this.props.runsetupforcompanyworkshop();
    const filteredNav = this.getCurrentNav();
    this.setState({ filteredNav });
  }

  handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filteredNav = this.filterNavigation(this.getCurrentNav(), searchTerm);
    this.setState({ searchTerm, filteredNav });
  };

  filterNavigation = (nav, searchTerm) => {
    return {
      ...nav,
      items: nav.items
        .map((item) => this.filterItem(item, searchTerm))
        .filter(Boolean),
    };
  };

  filterItem = (item, searchTerm) => {
    if (item.name.toLowerCase().includes(searchTerm)) {
      return item;
    }
    if (item.children) {
      const filteredChildren = item.children
        .map((child) => this.filterItem(child, searchTerm))
        .filter(Boolean);
      if (filteredChildren.length > 0) {
        return { ...item, children: filteredChildren };
      }
    }
    return null;
  };

  nestedFilterNavList = (arr=[], value) => [
      ...arr.filter((item) => item.files.findIndex((s) => s === value)>=0).map((item) => ({
        ...item,
        children: !!item.children ? this.nestedFilterNavList(item.children, value) : []
      }))
    ];

  filterNavList = (value) =>  ({
    items: this.nestedFilterNavList(navigation.items, value)
  })

  getCurrentNav = () => {
    const { authData } = this.props;

    if (!authData || !authData.result) {
      return this.filterNavList("_nav.js"); // default navigation
    }

    if (authData.result.id_type_company === 4) {
      return this.filterNavList("goodsTraderIntercompanyNav.jsx");
    }

    switch (authData.result.id_roles) {
      case 1:
      case 4:
      case 5:
        return this.filterNavList("_nav.js");
      case 2:
        return this.filterNavList("managerNav.jsx");
      case 3:
        return this.filterNavList("securityNav.jsx");
      case 6:
        return this.filterNavList("mechanicNav.jsx");
      case 7:
        return this.filterNavList("headMechanicNav.jsx");
      case 13:
        return this.filterNavList("hrNav.jsx");
      case 14:
        return this.filterNavList("maintenanceNav.jsx");
      default:
        return {items:[]};
    }
  };

  render() {
    const routesBreadCrumb = this.flatArray((this.props.breadcrumb??[]).map((item)=>({
      name: item.name,
      path: item.path
    }))) ?? [];

    let newProps = { ...this.props };
    delete newProps.runsetupforcompanyworkshop;
    delete newProps.inProgress;
    delete newProps.isAuthenticated;
    delete newProps.authData;
    delete newProps.email_verified;

    return (
      <AuthCheck>
        <WalletPayment>
          <Notification>
            <div
              className={`app ${wording["layout-site-classname"]}`}
            >
              <AppHeader fixed>
                <Suspense fallback={this.loading()}>
                  <DefaultHeader />
                </Suspense>
              </AppHeader>
              <div className="app-body">
                <AppSidebar fixed display="lg" minimized>
                  <AppSidebarHeader />
                  <AppSidebarForm>
                    <input
                      type="text"
                      className={`${styles["search-bar"]}`}
                      placeholder="Search..."
                      value={this.state.searchTerm}
                      onChange={this.handleSearchChange}
                    />
                  </AppSidebarForm>
                  <Suspense fallback={this.loading()}>
                    <DefaultSidebar
                      navConfig={this.state.filteredNav || this.getCurrentNav()}
                      {...newProps}
                    />
                    {/* <AppSidebarNav
                      navConfig={this.state.filteredNav || this.getCurrentNav()}
                      {...newProps}
                    /> */}
                  </Suspense>
                  <AppSidebarFooter />
                  <AppSidebarMinimizer />
                </AppSidebar>
                <main className="main">
                  <AppBreadcrumb appRoutes={routesBreadCrumb} />
                  <Container fluid>
                    {!this.props.email_verified ? (
                      <Alert color="warning">
                        <b>
                          <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                          Please verify your email! On 15 November 2022
                          unverified emails will be denied to access the
                          platform.
                        </b>
                      </Alert>
                    ) : null}
                    <DefaultTemplate>{this.props.children}</DefaultTemplate>
                  </Container>
                </main>
                <AppAside fixed>
                  <Suspense fallback={this.loading()}>
                    <DefaultAside />
                  </Suspense>
                </AppAside>
              </div>
              <AppFooter>
                <Suspense fallback={this.loading()}>
                  <DefaultFooter />
                </Suspense>
              </AppFooter>
            </div>
          </Notification>
        </WalletPayment>
      </AuthCheck>
    );
  }
}

function mapStateToProps(state) {
  return {
    authData: state.authStore.authData,
    inProgress: state.authStore.inProgress,
    isAuthenticated: state.authStore.isAuthenticated,
    email_verified: state.authStore.email_verified,
  };
}

export default connect(mapStateToProps, {
  runsetupforcompanyworkshop: runSetupForCompanyWorkshop,
})(DefaultLayout);
